import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import NoticePopup from './noticePopup.vue';
import { useUserStore } from '@/stores/user';
import { openPopup, safeNavigate } from '@/view/home/supportScript';
import GameSearchPopup from './gameSearchPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'noticeBar',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const userStore = useUserStore()
const router = useRouter()
const newsBarStyle = ref(
    {
        background_color: "",
        font_color: "",
        icon_color: ""
    }
)
const letIconImage = ref()
const NoticePopupRef = ref();
const gameSearchPopRef = ref()
const unreadMsgCount = computed(() => userStore.unreadCount)
const props = __props

const newsText = computed(() => {
    const text = props.itemData.text
    if (typeof text === 'string') return text
    const lang = localStorage.getItem('lang') || 'en'
    return text[lang] || text['en'] || ''
})

const openNoticePopup = () => {
    openPopup(NoticePopupRef)
}
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const openGameSearchPopup = () => {
    openPopup(gameSearchPopRef)
}
onMounted(() => {
    newsBarStyle.value.background_color = props.itemData.styles.background_color
    newsBarStyle.value.font_color = props.itemData.styles.font_color
    newsBarStyle.value.icon_color = props.itemData.styles.icon_color
    letIconImage.value = props.itemData.leftIcon_url

})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, { style: {"padding":"0 15px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_notice_bar, {
              onClick: openNoticePopup,
              class: "notice_container",
              style: _normalizeStyle({ background: newsBarStyle.value.background_color }),
              color: newsBarStyle.value.font_color,
              text: newsText.value,
              speed: "50"
            }, {
              "left-icon": _withCtx(() => [
                _createElementVNode("img", {
                  src: letIconImage.value,
                  alt: ""
                }, null, 8, _hoisted_1)
              ]),
              "right-icon": _withCtx(() => [
                (unreadMsgCount.value > 0)
                  ? (_openBlock(), _createBlock(_component_van_badge, {
                      key: 0,
                      content: unreadMsgCount.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "bell_img",
                          style: _normalizeStyle({ background: newsBarStyle.value.icon_color })
                        }, [
                          _createVNode(_component_van_icon, {
                            name: "chat-o",
                            onClick: goToMessage,
                            size: "22"
                          })
                        ], 4)
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "bell_img",
                      style: _normalizeStyle({ background: newsBarStyle.value.icon_color })
                    }, [
                      _createVNode(_component_van_icon, {
                        name: "chat-o",
                        onClick: goToMessage,
                        size: "22"
                      })
                    ], 4))
              ]),
              _: 1
            }, 8, ["style", "color", "text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(NoticePopup, {
      ref_key: "NoticePopupRef",
      ref: NoticePopupRef
    }, null, 512)
  ], 64))
}
}

})